/*
 *
 *  sagas
 *
 */

import { call, take, put, race, all } from "redux-saga/effects"

import {
  ADD_FOLLOWUP,
  UPDATE_FOLLOWUP,
  LOAD_FOLLOWUP_LIST,
  LOAD_RECORDS_META_DATA,
  LOAD_CHECK_LIST,
  LOAD_EC_FOLLOWUP_LIST,
  LOAD_TEAM_SCHEDULE,
  LOAD_EC_APP,
  LOAD_EC_EVENT,
  LOAD_DELIVERABLES,
  LOAD_DELIVER_META_DATA,
  LOAD_DELIVERABLE_STATUS,
  LOAD_ISSUES,
  LOAD_CALL_ACTIONS,
  LOAD_CALL_CRITERIA,
  LOAD_DELIVERABLE_TAG,
  ADD_ISSUES,
  UPDATE_ISSUES,
  DELETE_ISSUES,
  LOAD_CALL_RECORDING,
  UPDATE_NOTES,
  LOAD_REVIEW,
  ADD_REVIEW,
  UPDATE_REVIEW

} from "./constants"

import {
  loadRecordsMetaDataSuccess,
  loadRecordsMetaDataError,
  addOperationsFollowupSuccess,
  addOperationsFollowupError,
  updateOperationsFollowupSuccess,
  updateOperationsFollowupError,
  loadOperationsFollowup,
  loadOperationsFollowupSuccess,
  loadOperationsFollowupError,
  loadCheckList,
  loadCheckListSuccess,
  loadCheckListError,
  loadEcFollowupList,
  loadEcFollowupListSuccess,
  loadEcFollowupListError,
  loadTeamSchedule,
  loadTeamScheduleSuccess,
  loadTeamScheduleError,
  loadEcApp,
  loadEcAppSuccess,
  loadEcAppError,
  loadEcEvent,
  loadEcEventSuccess,
  loadEcEventError,
  loadDeliverables,
  loadDeliverablesSuccess,
  loadDeliverablesError,
  loadDeliverMetaDataSuccess,
  loadDeliverMetaDataError,
  loadDeliverableStatus,
  loadDeliverableStatusSuccess,
  loadDeliverableStatusError,
  loadIssues,
  loadIssuesSuccess,
  loadIssuesError,
  loadCallCriteria,
  loadCallCriteriaSuccess,
  loadCallCriteriaError,
  loadcallActions,
  loadcallActionsSuccess,
  loadcallActionsError,
  loadDeliverableTag,
  loadDeliverableTagSuccess,
  loadDeliverableTagError,
  addIssuesSuccess,
  addIssuesError,
  updateIssuesSuccess,
  updateIssuesError,
  deleteIssuesSuccess,
  deleteIssuesError,
  loadCallRecording,
  loadCallRecordingSuccess,
  loadCallRecordingError,
  updateNotesSuccess,
  updateNotesError,
  loadReview,
  loadReviewSuccess,
  loadReviewError,
  addReviewSuccess,
  addReviewError,
  updateReviewSuccess,
  updateReviewError

  
} from "./actions"

import {
  loadRecordsMetaData,
  addOperationsFollowupDetails,
  updateOperationsFollowupDetails,
  loadOperationsFollowupDetails,
  loadCheckListApi,
  loadEcFollowupDetails,
  loadTeamScheduleApi,
  loadEcAppApi,
  loadEcEventApi,
  loadDeliverablesAPi,
  loadDeliverableStatusApi,
  loadIssuesApi,
  loadcallActionsApi,
  loadCallCriteriaApi,
  loadDeliverableTagApi,
  addIssuesDetails,
  updateIssuesDetails,
  deleteIssuesDetails,
  loadcallRecordingApi,
  updateNotesApi,
  addReviewApi,
  updateReviewApi,
  loadReviewDetails
} from "./remotes"


function* loadEcFollowupListSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const load = yield race({
      explicitLoad: take(LOAD_EC_FOLLOWUP_LIST),
    })

    const { explicitLoad } = load

    const { id } = explicitLoad || {}
    yield put(loadEcFollowupList(explicitLoad.id)) // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadEcFollowupDetails, id)

        if (result) {
          yield put(loadEcFollowupListSuccess(result.data))
        } else {
          yield put(loadEcFollowupListError("Fetch Records Failed"))
        }
      } catch (error) {
        yield put(
          loadEcFollowupListError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        )
      }
    }
  }
}
//Special Instructions
function* loadOperationsFollowupSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const load = yield race({
      explicitLoad: take(LOAD_FOLLOWUP_LIST),
    })

    const { explicitLoad } = load

    const { id } = explicitLoad || {}
    yield put(loadOperationsFollowup(explicitLoad.id)) // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadOperationsFollowupDetails, id)

        if (result) {
          yield put(loadOperationsFollowupSuccess(result.data))
        } else {
          yield put(loadOperationsFollowupError("Fetch Records Failed"))
        }
      } catch (error) {
        yield put(
          loadOperationsFollowupError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        )
      }
    }
  }
}

function* addOperationsFollowupSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { create } = yield race({
      create: take(ADD_FOLLOWUP),
    })
    const { operationsFollowupData } = create || {}

    if (create) {
      console.log("records", operationsFollowupData)
      try {
        yield call(addOperationsFollowupDetails, operationsFollowupData)

        var successVal = addOperationsFollowupSuccess(
          operationsFollowupData,
          "Record Created Successfully"
        )

        yield put(successVal)
      } catch (error) {
        yield put(
          addOperationsFollowupError(
            (error && error.response && error.response.message) ||
              "Create Record Failed"
          )
        )
      } finally {
        // yield call(setSubmitting, false)
      }
    }
  }
}

function* updateFollowupSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { edit } = yield race({
      edit: take(UPDATE_FOLLOWUP),
    })

    const { updateFollowupData, record } = edit || {}
    if (edit) {
      try {
        yield call(updateOperationsFollowupDetails, updateFollowupData)
        // yield delay(1000)
        yield put(
          updateOperationsFollowupSuccess(
            updateFollowupData,
            record,
            "Record Updated Successfully"
          )
        )
        // yield call(redirect)
      } catch (error) {
        yield put(
          updateOperationsFollowupError(
            (error && error.response && error.response.message) ||
              "Update Record Failed"
          )
        )
      } finally {
        // yield call(setSubmitting, false)
      }
    }
  }
}

function* loadRecordsMetaDataSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    yield race({
      metaData: take(LOAD_RECORDS_META_DATA),
    })

    try {
      const followupMode = yield call(
        loadRecordsMetaData,
        "all_followup_master",
        "post"
      )
      const followupAction = yield call(
        loadRecordsMetaData,
        "all_followup_action",
        "post"
      )
      const department = yield call(loadRecordsMetaData, "all_department", "post")
      const employee = yield call ( loadRecordsMetaData,
        "all_employee_dropdown_list",
        "post")
      const language = yield call(loadRecordsMetaData,"Language","post")

      const followup = yield call(loadRecordsMetaData,"all_deliverable_followup_reason","post")

      let recordsMetaData = {
        languageOptions:
        (language &&
          language.data &&
          language.data.length > 0 &&
          language.data
            .filter((_) => _.status === 1)
            .map((e) =>
              Object.assign(
                {},
                {
                  label: e.languageName,
                  value: e._id,
                }
              )
            )) ||
        [],
        followupReasonOptions:
        (followup &&
          followup.data &&
          followup.data.length > 0 &&
          followup.data
            .filter((_) => _.status === 1)
            .map((e) =>
              Object.assign(
                {},
                {
                  label: e.reasonName,
                  value: e._id,
                }
              )
            )) ||
        [], 
        followUpModeOptions:
          (followupMode &&
            followupMode.data &&
            followupMode.data.length > 0 &&
            followupMode.data
              .filter((_) => _.status === 1)
              .map((e) =>
                Object.assign(
                  {},
                  {
                    label: e.followupMaster,
                    value: e._id,
                  }
                )
              )) ||
          [],
        followUpStatusOptions:
          (followupAction &&
            followupAction.data &&
            followupAction.data.length > 0 &&
            followupAction.data
              .filter((_) => _.status === 1)
              .map((e) =>
                Object.assign(
                  {},
                  {
                    label: `${e.followupAction}`,
                    value: e._id,
                  }
                )
              )) ||
          [],
          departmentOptions:
          (department &&
            department.data &&
            department.data.length > 0 &&
            department.data.filter(_=> _.status === 1).map((c) =>
              Object.assign({}, { label: c.name, value: c._id })
            )) ||
          (department &&
            department.length > 0 &&
            department.map((c) =>
              Object.assign({}, { label: c.name, value: c._id })
            )) ||
          [],
          employeeOptions:
          (employee &&
            employee.data &&
            employee.data.length > 0 &&
            employee.data
             
              .map((c) =>
                Object.assign(
                  {},
                  {
                    label:c.empCode.concat(" - ", c.name),
                    value: c._id,
                    
                  }
                )
              )) ||
          [],
      }

      console.log("recordsMetaData-->", recordsMetaData)

      yield put(loadRecordsMetaDataSuccess(recordsMetaData))
    } catch (error) {
      yield put(
        loadRecordsMetaDataError(
          (error && error.response && error.response.message) ||
            "Fetch Dropdown Records Failed"
        )
      )
    }
  }
}
function* loadCheckListSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const load = yield race({
      explicitLoad: take(LOAD_CHECK_LIST),
    })

    const { explicitLoad } = load

    const { id } = explicitLoad || {}
    yield put(loadCheckList(explicitLoad.id)) // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadCheckListApi, id)

        if (result) {
          yield put(loadCheckListSuccess(result.data))
        } else {
          yield put(loadCheckListError("Fetch Records Failed"))
        }
      } catch (error) {
        yield put(
          loadCheckListError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        )
      }
    }
  }
}

function* loadTeamScheduleSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const load = yield race({
      explicitLoad: take(LOAD_TEAM_SCHEDULE),
    })

    const { explicitLoad } = load

    const { id } = explicitLoad || {}
    yield put(loadTeamSchedule(explicitLoad.id)) // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadTeamScheduleApi, id)

        if (result) {
          yield put(loadTeamScheduleSuccess(result.data))
        } else {
          yield put(loadTeamScheduleError("Fetch Records Failed"))
        }
      } catch (error) {
        yield put(
          loadTeamScheduleError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        )
      }
    }
  }
}


function* loadEcAppSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const load = yield race({
      explicitLoad: take(LOAD_EC_APP),
    })

    const { explicitLoad } = load

    const { id } = explicitLoad || {}
    yield put(loadEcApp(explicitLoad.id)) // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadEcAppApi, id)

        if (result) {
          yield put(loadEcAppSuccess(result.data))
        } else {
          yield put(loadEcAppError("Fetch Records Failed"))
        }
      } catch (error) {
        yield put(
          loadEcAppError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        )
      }
    }
  }
}


function* loadEcEventSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const load = yield race({
      explicitLoad: take(LOAD_EC_EVENT),
    })

    const { explicitLoad } = load

    const { id } = explicitLoad || {}
    yield put(loadEcEvent(explicitLoad.id)) // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadEcEventApi, id)

        if (result) {
          yield put(loadEcEventSuccess(result.data))
        } else {
          yield put(loadEcEventError("Fetch Records Failed"))
        }
      } catch (error) {
        yield put(
          loadEcEventError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        )
      }
    }
  }
}


function* loadDeliverablesSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const load = yield race({
      explicitLoad: take(LOAD_DELIVERABLES),
    })

    const { explicitLoad } = load

    const { id } = explicitLoad || {}
    yield put(loadDeliverables(explicitLoad.id)) // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadDeliverablesAPi, id)

        if (result) {
          yield put(loadDeliverablesSuccess(result.data))
        } else {
          yield put(loadDeliverablesError("Fetch Records Failed"))
        }
      } catch (error) {
        yield put(
          loadDeliverablesError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        )
      }
    }
  }
}

function* loadDeliverMetaDataSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    yield race({
      metaData: take(LOAD_DELIVER_META_DATA),
    })

    try {
      const processStatus = yield call(loadRecordsMetaData, "process_status", "post")

      let deliverMetaData = {
        processStatusOptions:
          (processStatus &&
            processStatus.data &&
            processStatus.data.length > 0 &&
            processStatus.data
              .filter((_) => _.status === 1)
              .map((p) =>
                Object.assign(
                  {},
                  {
                    label: p.processStatus,
                    value: p._id,
                    processStatusId: p.processStatusId,
                    colorCode: p.colorCode,
                  }
                )
              )) ||
          [],
      }

      console.log("recordsMetaData-->", deliverMetaData)

      yield put(loadDeliverMetaDataSuccess(deliverMetaData))
    } catch (error) {
      yield put(
        loadDeliverMetaDataError(
          (error && error.response && error.response.message) ||
            "Fetch Dropdown Records Failed"
        )
      )
    }
  }
}

function* loadDeliverableStatusSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const load = yield race({
      explicitLoad: take(LOAD_DELIVERABLE_STATUS),
    })

    const { explicitLoad } = load

    const { id } = explicitLoad || {}
    yield put(loadDeliverableStatus(explicitLoad.id)) // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadDeliverableStatusApi, id)

        if (result) {
          yield put(loadDeliverableStatusSuccess(result.data))
        } else {
          yield put(loadDeliverableStatusError("Fetch Records Failed"))
        }
      } catch (error) {
        yield put(
          loadDeliverableStatusError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        )
      }
    }
  }
}

//loadIssues saga
function* loadIssuesSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const load = yield race({
      explicitLoad: take(LOAD_ISSUES),
    })

    const { explicitLoad } = load

    const { id } = explicitLoad || {}
    yield put(loadIssues(explicitLoad.id)) // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadIssuesApi, id)

        if (result) {
          yield put(loadIssuesSuccess(result.data))
        } else {
          yield put(loadIssuesError("Fetch Records Failed"))
        }
      } catch (error) {
        yield put(
          loadIssuesError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        )
      }
    }
  }
}
//loadCallCriteria
function* loadCallCriteriaSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const load = yield race({
      explicitLoad: take(LOAD_CALL_CRITERIA),
    })

    const { explicitLoad } = load

    const { id } = explicitLoad || {}
    yield put(loadCallCriteria(explicitLoad.id)) // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadCallCriteriaApi, id)

        if (result) {
          yield put(loadCallCriteriaSuccess(result.data))
        } else {
          yield put(loadCallCriteriaError("Fetch Records Failed"))
        }
      } catch (error) {
        yield put(
          loadCallCriteriaError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        )
      }
    }
  }
}
//loadcallActions
function* loadcallActionsSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const load = yield race({
      explicitLoad: take(LOAD_CALL_ACTIONS,
    )})

    const { explicitLoad } = load

    const { id } = explicitLoad || {}
    yield put(loadcallActions(explicitLoad.id)) // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadcallActionsApi, id)

        if (result) {
          yield put(loadcallActionsSuccess(result.data))
        } else {
          yield put(loadcallActionsError("Fetch Records Failed"))
        }
      } catch (error) {
        yield put(
          loadcallActionsError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        )
      }
    }
  }
}

//loadDeliverableTag
function* loadDeliverableTagSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const load = yield race({
      explicitLoad: take(LOAD_DELIVERABLE_TAG,
    )})

    const { explicitLoad } = load

    const { id } = explicitLoad || {}
    yield put(loadDeliverableTag(explicitLoad.id)) // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadDeliverableTagApi, id)

        if (result) {
          yield put(loadDeliverableTagSuccess(result.data))
        } else {
          yield put(loadDeliverableTagError("Fetch Records Failed"))
        }
      } catch (error) {
        yield put(
          loadDeliverableTagError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        )
      }
    }
  }
}
//addIssues
function* addIssuesSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { create } = yield race({
      create: take(ADD_ISSUES),
    })
    const { issueData } = create || {}

    if (create) {
      console.log("records", issueData)
      try {
        yield call(addIssuesDetails, issueData)

        var successVal = addIssuesSuccess(
          issueData,
          "Record Created Successfully"
        )

        yield put(successVal)
      } catch (error) {
        yield put(
          addIssuesError(
            (error && error.response && error.response.message) ||
              "Create Record Failed"
          )
        )
      } finally {
        // yield call(setSubmitting, false)
      }
    }
  }
}
//updateIssues
function* updateIssuesSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { create } = yield race({
      create: take(UPDATE_ISSUES),
    })
    const { issuesUpdate } = create || {}

    if (create) {
      console.log("records", issuesUpdate)
      try {
        yield call(updateIssuesDetails,issuesUpdate)

        var successVal = updateIssuesSuccess(
          issuesUpdate,
          "Record Created Successfully"
        )

        yield put(successVal)
      } catch (error) {
        yield put(
          updateIssuesError(
            (error && error.response && error.response.message) ||
              "Create Record Failed"
          )
        )
      } finally {
        // yield call(setSubmitting, false)
      }
    }
  }
}
//deleteIssues
function* deleteIssuesSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { create } = yield race({
      create: take(DELETE_ISSUES),
    })
    const { deleteIssues } = create || {}

    if (create) {
      console.log("records", deleteIssues)
      try {
        yield call(deleteIssuesDetails,deleteIssues)

        var successVal = deleteIssuesSuccess(
          deleteIssues,
          "Record Created Successfully"
        )

        yield put(successVal)
      } catch (error) {
        yield put(
          deleteIssuesError(
            (error && error.response && error.response.message) ||
              "Create Record Failed"
          )
        )
      } finally {
        // yield call(setSubmitting, false)
      }
    }
  }
}
//loadcallActions
function* loadcallRecordingSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const load = yield race({
      explicitLoad: take(LOAD_CALL_RECORDING,
    )})

    const { explicitLoad } = load

    const { id } = explicitLoad || {}
    yield put(loadCallRecording(explicitLoad.id)) // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadcallRecordingApi, id)

        if (result) {
          yield put(loadCallRecordingSuccess(result.data))
        } else {
          yield put(loadCallRecordingError("Fetch Records Failed"))
        }
      } catch (error) {
        yield put(
          loadCallRecordingError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        )
      }
    }
  }
}

//updateNotes
function* updateNotesSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { create } = yield race({
      create: take(UPDATE_NOTES),
    })
    const { notes_data } = create || {}

    if (create) {
     
      try {
        yield call(updateNotesApi,notes_data)

        var successVal = updateNotesSuccess(
         
          "Record Created Successfully"
        )

        yield put(successVal)
      } catch (error) {
        yield put(
          updateNotesError(
            (error && error.response && error.response.message) ||
              "Create Record Failed"
          )
        )
      } finally {
        // yield call(setSubmitting, false)
      }
    }
  }
}

//review
//loadReview REVIEW
function* loadReviewSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const load = yield race({
      explicitLoad: take(LOAD_REVIEW,
    )})

    const { explicitLoad } = load

    const { id } = explicitLoad || {}
    yield put(loadReview(explicitLoad.id)) // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadReviewDetails, id)

        if (result) {
          yield put(loadReviewSuccess(result.data))
        } else {
          yield put(loadReviewError("Fetch Records Failed"))
        }
      } catch (error) {
        yield put(
          loadReviewError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        )
      }
    }
  }
}

//updateReview
function* updateReviewSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { create } = yield race({
      create: take(UPDATE_REVIEW),
    })
    const {updateReview_data} = create || {}

    if (create) {
     
      try {
        yield call(updateReviewApi, updateReview_data)

        var successVal = updateReviewSuccess(
         
          "Record Created Successfully"
        )

        yield put(successVal)
      } catch (error) {
        yield put(
          updateReviewError(
            (error && error.response && error.response.message) ||
              "Create Record Failed"
          )
        )
      } finally {
        // yield call(setSubmitting, false)
      }
    }
  }
}


//addReview
function* addReviewSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { create } = yield race({
      create: take(ADD_REVIEW),
    })
    const {reviewAdd_data} = create || {}

    if (create) {
     
      try {
        yield call(addReviewApi, reviewAdd_data)

        var successVal = addReviewSuccess(
         
          "Record Created Successfully"
        )

        yield put(successVal)
      } catch (error) {
        yield put(
          addReviewError(
            (error && error.response && error.response.message) ||
              "Create Record Failed"
          )
        )
      } finally {
        // yield call(setSubmitting, false)
      }
    }
  }
}
export default function* recordsSaga() {
  yield all([
    loadRecordsMetaDataSaga(),
    loadEcFollowupListSaga(),
    loadOperationsFollowupSaga(),
    addOperationsFollowupSaga(),
    updateFollowupSaga(),
    loadCheckListSaga(),
    loadTeamScheduleSaga(),
    loadEcAppSaga(),
    loadEcEventSaga(),
    loadDeliverablesSaga(),
    loadDeliverMetaDataSaga(),
    loadDeliverableStatusSaga(),
    loadIssuesSaga(),
    loadCallCriteriaSaga(),
    loadcallActionsSaga(),
    loadDeliverableTagSaga(),
    addIssuesSaga(),
    updateIssuesSaga(),
    deleteIssuesSaga(),
    loadcallRecordingSaga(),
    updateNotesSaga(),
    loadReviewSaga(),
    updateReviewSaga(),
    addReviewSaga()
  ])
}
